// ============================================================================
// Font Loader — Dynamic Google Fonts injection (M8)
// ============================================================================

import { FONT_PAIRS, AVAILABLE_FONTS } from '../../editor/constants/typographyPresets';

const loadedFonts = new Set<string>();

export function loadFontPair(fontPairId: string): void {
  if (loadedFonts.has(fontPairId)) return;
  const pair = FONT_PAIRS.find((p) => p.id === fontPairId);
  if (!pair) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = pair.googleUrl;
  document.head.appendChild(link);
  loadedFonts.add(fontPairId);
}

export function loadFontById(fontId: string): void {
  // System fonts are always loaded — skip
  const font = AVAILABLE_FONTS.find((f) => f.id === fontId);
  if (!font || font.source === 'system') return;

  // Find the font pair that contains this font and load it
  const pair = FONT_PAIRS.find(
    (p) => p.heading.includes(font.label) || p.body.includes(font.label),
  );
  if (pair) {
    loadFontPair(pair.id); // Reuse existing loader
  }
}
